import { render, staticRenderFns } from "./PricingTable.vue?vue&type=template&id=58c1d0b6&scoped=true&"
import script from "./PricingTable.vue?vue&type=script&lang=js&"
export * from "./PricingTable.vue?vue&type=script&lang=js&"
import style0 from "./PricingTable.vue?vue&type=style&index=0&id=58c1d0b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c1d0b6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AddToCartButton: require('/app/appsumo/nuxt/components/products/pricing-table/AddToCartButton.vue').default,PricingItem: require('/app/appsumo/nuxt/components/products/pricing-table/PricingItem.vue').default})
